<template>
  <div class="premium-modal-test">
    <h3>Premium modal</h3>
    <ul>
      <li v-for="(code, index) in premiumCodes" :key="index">
        <strong v-if="code === getPremiumModalCode">{{ code }}</strong>
        <span v-else>{{ code }}</span>
      </li>
    </ul>
    <div class="test-buttons">
      <button @click="prevPremiumModal">prev</button>
      <button @click="nextPremiumModal">next</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import PremiumService from "@/store/services/premium.service.js";

export default {
  data () {
    return {
      premiumCodes: [],
      currentIndex: 0,
    };
  },
  computed: {
    ...mapGetters({
      getPremiumModalCode: "getPremiumModalCode",
    }),
    nextModalCode() {
      return this.premiumCodes[this.nextCodeIndex];
    },
    nextCodeIndex() {
      return (this.currentIndex + 1) % this.premiumCodes.length;
    },
    prevModalCode() {
      return this.premiumCodes[this.prevCodeIndex];
    },
    prevCodeIndex() {
      return (this.currentIndex - 1 + this.premiumCodes.length) % this.premiumCodes.length;
    },
  },
  created () {
    this.setupData()
  },
  methods: {
    ...mapMutations({
      setPremiumModalCode: "SET_PREMIUM_MODAL_CODE",
    }),
    setupData () {
      PremiumService.list().then((response) => {
        this.premiumCodes = response.data.map(item => item.code)
        this.currentIndex = this.premiumCodes.indexOf(this.getPremiumModalCode);
      })
    },
    nextPremiumModal() {
      this.currentIndex = this.nextCodeIndex;
      this.setPremiumModalCode(this.premiumCodes[this.currentIndex]);
    },
    prevPremiumModal() {
      this.currentIndex = this.prevCodeIndex;
      this.setPremiumModalCode(this.premiumCodes[this.currentIndex]);
    },
  },
};
</script>

<style lang="scss" scoped>
.premium-modal-test {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 10000;
  padding: 1rem;
  background: white;
  width: 240px;
  h3 { margin: 0; font-size: 20px; }
  ul {
    margin: 0;
    padding: 0;
    li {
      font-size: 14px;
      > span {
        color: $colorTextLight;
      }
    }
    padding: 1rem 0.5rem;
  }

  .test-buttons {
    display: flex;
    width: 100%;
    button { flex: 1; }
  }
}



</style>
